var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook2 = function SvgFacebook2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 256 256"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.129 136.346h28.062v115.525A4.13 4.13 0 0 0 99.32 256h47.579a4.13 4.13 0 0 0 4.129-4.129V136.89h32.26a4.13 4.13 0 0 0 4.102-3.658l4.899-42.53a4.127 4.127 0 0 0-4.101-4.602H151.03V59.44c0-8.037 4.327-12.112 12.863-12.112h24.295a4.13 4.13 0 0 0 4.129-4.13V4.16a4.13 4.13 0 0 0-4.129-4.13h-33.482a33 33 0 0 0-1.534-.03c-5.809 0-26.003 1.14-41.954 15.815-17.674 16.262-15.217 35.733-14.63 39.109v31.175H67.129A4.13 4.13 0 0 0 63 90.23v41.987a4.13 4.13 0 0 0 4.129 4.13"
  })));
};
export default SvgFacebook2;